import { Col, Row } from 'antd';

import type { Database_Procs_GetPlayerFamily_Item } from '@suntex.fim/api-client';
import { handleKeyboardClick } from '@suntex.fim/ui';

export interface FamilyLinkStatsProps {
  familyLinkData: Database_Procs_GetPlayerFamily_Item;
  showPassword: boolean;
  onPasswordClick: () => void;
  colProps: {
    xs: { flex: string };
    sm: { flex: string };
    md: { flex: string };
    xl: { flex: string };
  };
}

export function FamilyLinkStats({
  familyLinkData,
  showPassword,
  onPasswordClick,
  colProps,
}: FamilyLinkStatsProps) {
  const familyScore =
    familyLinkData.familyStickers + familyLinkData.primaryStickers;

  const passwordDisplay = showPassword ? (
    <>
      <span className="label">Password:</span>
      <span className="numbers">{familyLinkData.familyPassword}</span>
    </>
  ) : (
    'Show Password'
  );

  const handleMouseEnter = () => {
    if (!showPassword) {
      onPasswordClick();
    }
  };

  const handleMouseLeave = () => {
    if (showPassword) {
      onPasswordClick();
    }
  };

  return (
    <Row>
      <Col
        {...colProps}
        xxl={{ flex: '50%' }}
        className="stat familylink__stat"
      >
        <span className="label">User</span>
        <span className="numbers">{familyLinkData.familyUserId}</span>
      </Col>
      <Col
        {...colProps}
        xxl={{ flex: '50%' }}
        className="stat familylink__stat"
      >
        <span className="label">Family Score</span>
        <span className="numbers">{familyScore.toLocaleString()}</span>
      </Col>
      <Col
        {...colProps}
        xxl={{ flex: '50%' }}
        className="stat familylink__stat"
      >
        <span className="label">Score</span>
        <span className="numbers">
          {familyLinkData.familyStickers.toLocaleString()}
        </span>
      </Col>
      <Col
        {...colProps}
        xxl={{ flex: '0 0 25%' }}
        className="stat familylink__stat familylink__password"
      >
        <div
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          style={{ cursor: 'pointer' }}
        >
          <span
            aria-label="family-link-password"
            className="familylink__password"
            role="button"
            tabIndex={0}
            onFocus={handleMouseEnter}
            onBlur={handleMouseLeave}
            onKeyDown={(e) => {
              handleKeyboardClick(e);
            }}
          >
            {passwordDisplay}
          </span>
        </div>
      </Col>
    </Row>
  );
}
